import axios from 'axios';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './Contact.css'

function titlee() {
  return document.getElementById('titlee');
}

let title = titlee();

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      line1: 'Talk With Me !!',
      closeClassName: 'far fa-times-circle',
      textAnimationLine1: [],
      loading: false,
      Name: '',
      Email: '',
      Subject: '',
      Body: '',
      SendMessageUrl: 'https://my-webpage-node.vercel.app/Contact/Message',
      ShowPopUp: false,
      DataReceived: false,
      errorDataReceived: false,
      errorName: false,
      errorEmail: false,
      errorSubject: false,
      errorBody: false
    }
  }
  async componentDidMount() {
    title.innerHTML = 'Contact'
    this.setState({
      loading: true
    })
    let tempArr1 = []
    if (this.state.textAnimationLine1.length !== 40) {
      for (let i = 0; i < 40; i++) {
        tempArr1[i] = { letterAni: 0 }
      }
    }
    this.setState({
      textAnimationLine1: tempArr1,
    })
    let ContactPage = {
      SelectedPage: 4
    }
    this.props.SelectedPage('SelectedPage', ContactPage)
    var countDownAni = 0;
    setInterval(() => {
      if ((countDownAni) < 40 && this.state.loading) {
        let arr1 = this.state.textAnimationLine1;
        if (countDownAni === 0) {
          arr1[countDownAni] = { letterAni: 1 }
          countDownAni++;
          this.setState({
            textAnimationLine1: arr1,
          })
        } else {
          arr1[countDownAni - 1] = { letterAni: 2 }
          arr1[countDownAni] = { letterAni: 1 }
          countDownAni++;
          this.setState({
            textAnimationLine1: arr1,
          })
        }
      }
    }, 100);
  }

  render() {
    return (<>
      <div className='contactMainDivision'>
        <div className='mainDivContactPage'>
          <div className='TextDivisionContact'>
            <div>
              {this.state.line1.split('').map((ite, index) => {
                return (<>{ite === ' ' ? <span className='ContactAniLetterSpace'>{ite}</span> : <span onMouseEnter={() => {
                  let ani = this.state.textAnimationLine1
                  ani[index] = { letterAni: 1 }
                  this.setState({
                    textAnimationLine1: ani
                  })
                }} onMouseLeave={() => {
                  setTimeout(() => {
                    let ani = this.state.textAnimationLine1
                    ani[index] = { letterAni: 2 }
                    this.setState({
                      textAnimationLine1: ani
                    })
                  }, 500)
                }} className={this.state.textAnimationLine1[index]?.letterAni === 0 || undefined || null ? 'ContactAniLtr' : this.state.textAnimationLine1[index]?.letterAni === 1 ? 'ContactAniLetterMouse ContactAniLetter' : 'ContactAniLetter'}>{ite}</span>}
                </>)
              })}
            </div>
          </div>
        </div>
        <div className='ContactFormDivision'>
          <form className='contactDivFormMain' onSubmit={async (e) => {
            e.preventDefault();
            let val = new RegExp('^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$')
            let emailChk = val.test(this.state.Email)
            if (this.state.Name === '' || this.state.Name.trim().length <= 0) {
              this.setState({
                errorName: true
              })
            } else {
              this.setState({
                errorName: false
              })
            }
            if (this.state.Email === '' || this.state.Email.trim().length <= 0 || !emailChk) {
              this.setState({
                errorEmail: true
              })
            } else {
              this.setState({
                errorEmail: false
              })
            }
            if (this.state.Subject === '' || this.state.Subject.trim().length <= 0) {
              this.setState({
                errorSubject: true
              })
            } else {
              this.setState({
                errorSubject: false
              })
            }
            if (this.state.Body === '' || this.state.Body.trim().length <= 0) {
              this.setState({
                errorBody: true
              })
            } else {
              this.setState({
                errorBody: false
              })
            }
            if (this.state.Name === '' || this.state.Name.trim().length <= 0 || this.state.Email === '' || this.state.Email.trim().length <= 0 || !emailChk || this.state.Subject === '' || this.state.Subject.trim().length <= 0 || this.state.Body === '' || this.state.Body.trim().length <= 0) {
              return
            }
            let timee = new Date();
            let val1 = '';
            let val2 = '';
            val1 = timee.getHours().toString().length === 1 ? '0' + timee.getHours().toString() : timee.getHours().toString();
            val1 += ':';
            val1 += timee.getMinutes().toString().length === 1 ? '0' + timee.getMinutes().toString() : timee.getMinutes().toString();
            val1 += ':';
            val1 += timee.getSeconds().toString().length === 1 ? '0' + timee.getSeconds().toString() : timee.getSeconds().toString();
            val2 += timee.getDate().toString().length === 1 ? '0' + timee.getDate().toString() : timee.getDate().toString();
            val2 += '-';
            val2 += timee.toDateString().split(' ')[1];
            val2 += '-';
            val2 += timee.getFullYear().toString();
            val1 = val1 + ' ' + val2
            let Data = {
              data: {
                name: this.state.Name,
                email: this.state.Email,
              },
              message: {
                subject: this.state.Subject,
                body: this.state.Body,
                time: val1
              }
            }
            try {
              if (!this.state.errorName && !this.state.errorEmail && !this.state.errorSubject && !this.state.errorBody) {
                this.setState({
                  ShowPopUp: true,
                  errorName: false,
                  errorEmail: false,
                  errorSubject: false,
                  errorBody: false
                })
                await axios.post(this.state.SendMessageUrl, Data).then((e) => {
                  if (e.data.status === 'error') {
                    console.log(e.data.error)
                    this.setState({
                      errorDataReceived: true,
                      DataReceived: true
                    })
                  } else {
                    this.setState({
                      errorDataReceived: false,
                      DataReceived: true,
                      Name: '',
                      Email: '',
                      Subject: '',
                      Body: ''
                    })
                  }
                })
              }
            }
            catch (e) {
              console.log(e)
            }
          }}>
            <div className='formHeadingDivContact'>Please Enter your doubts/queries in the below form and i will reach you within 24 hours.</div>
            <div className='contactDivFormNameEmailWrapper'>
              <input className={this.state.errorName ? 'contactDivFormNameError' : 'contactDivFormName'} type={'text'} placeholder={'Name'} onChange={(e) => {
                this.setState({
                  Name: e.target.value,
                  errorName: false
                })
              }} value={this.state.Name} />
              <input className={this.state.errorEmail ? 'contactDivFormEmailError' : 'contactDivFormEmail'} type={'email'} placeholder={'Email'} onChange={(e) => {
                this.setState({
                  Email: e.target.value,
                  errorEmail: false
                })
              }} value={this.state.Email} />
            </div>
            <div className='contactDivFormSubjectWrapper'>
              <input className={this.state.errorSubject ? 'contactDivFormSubjectError' : 'contactDivFormSubject'} type={'text'} placeholder={'Subject'} onChange={(e) => {
                this.setState({
                  Subject: e.target.value,
                  errorSubject: false
                })
              }} value={this.state.Subject} />
            </div>
            <div className='contactDivFormBodyWrapper'>
              <textarea placeholder='Body' className={this.state.errorBody ? 'contactDivFormBodyError' : 'contactDivFormBody'} onChange={(e) => {
                this.setState({
                  Body: e.target.value,
                  errorBody: false
                })
              }} value={this.state.Body}></textarea>
            </div>
            <div className='contactDivFormSendWrapper'>
              <input className='contactDivFormSend' type={'submit'} value='Send Message' />
            </div>
          </form>
          <div className='ContactDivisionRight'>
            <div className='contactDivisionInsideRight'>
              <div>
                <h2 className='contactDivisionInsideHeading'>Email</h2>
                <div>shanmugaveljagadeesan10@gmail.com</div>
              </div>
              <div>
                <h2 className='contactDivisionInsideHeading'>Connect With Me</h2>
                <div>
                  <a className='SLinkHyper' target="_blank" rel='noreferrer noopener' href='https://www.linkedin.com/in/shanmugaveljagadeesan'>
                    <i className="fab fa-linkedin-in ContactLogoSocial"></i>
                  </a>
                  <a className='SLinkHyper' target="_blank" rel='noreferrer noopener' href='https://github.com/Shanmugavel-J'>
                    <i className="fab fa-github ContactLogoSocial LMLeft"></i>
                  </a>
                  {/* <a className='SLinkHyper' target="_blank" rel='noreferrer noopener' href='https://wa.me/918428037564'>
                                        <i className="fab fa-whatsapp LMLeft ContactLogoSocial"></i>
                                    </a> */}
                  <a className='SLinkHyper' target="_blank" rel='noreferrer noopener' href='https://www.instagram.com/_shan_2510/'>
                    <i className="fab fa-instagram LMLeft ContactLogoSocial"></i>
                  </a>
                  <a className='SLinkHyper' target="_blank" rel='noreferrer noopener' href='https://www.facebook.com/shanmugavelj10/'>
                    <i className="fab fa-facebook LMLeft ContactLogoSocial"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.ShowPopUp ?
          <div className='contactPopUpDivision'>
            <div className='contactPopUpMainDivision'>
              <div className='contactPopUpStartDivision'>
                <div className='popUpDivisionHeading'>
                  Message Box
                </div>
                <i className={this.state.closeClassName + ' popUpCloseWindow'} onMouseEnter={() => {
                  this.setState({
                    closeClassName: 'fas fa-times-circle'
                  })
                }} onMouseLeave={() => {
                  this.setState({
                    closeClassName: 'far fa-times-circle'
                  })
                }} onClick={() => {
                  this.setState({
                    ShowPopUp: false,
                    DataReceived: false,
                    errorDataReceived: false,
                    closeClassName: 'far fa-times-circle'
                  })
                }}></i>
              </div>
              <div className='ContactPopUpDivisionMessage'>
                {this.state.DataReceived ? this.state.errorDataReceived ? 'Error' : 'Sent Message' : 'Sending Message'}
              </div>
            </div>
          </div>
          : ''}
      </div>
    </>);
  }
}

const mapStateToProps = () => ({

})

const mapDispatchToProps = (dispatch) => ({
  SelectedPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  })
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Contact));